import { Box, CircularProgress, Fade } from '@mui/material';

const ChartItem = (props) => {
  const { height, width, sx } = props;
  return (
    <Box className={`chart-loader`} sx={{ height: 160, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      <Fade
        in={true}
        style={{
          transitionDelay: true ? '800ms' : '0ms',
        }}
        unmountOnExit
      >
        <CircularProgress color="inherit" />
      </Fade>
    </Box>
  );
}

export default ChartItem;
